import AccountCircle from '@mui/icons-material/AccountCircle'
import { InputAdornment } from '@mui/material'
import { Box } from '@mui/system'
import React, { FC } from 'react'

import iranflag from '../assests/icons/iranflag.png'
import { IsItem } from '../interfaces/IsItem'
import Input from './Input'
import Select from './Select'
const types: IsItem[] = [
  { id: '1', label: 'الف', value: 'الف' },
  { id: '2', label: 'ب', value: 'ب' },
  { id: '3', label: 'ت', value: 'ت' },
  { id: '5', label: 'ج', value: 'ج' },
  { id: '6', label: 'د', value: 'د' },
  { id: '7', label: 'س', value: 'س' },
  { id: '8', label: 'ص', value: 'ص' },
  { id: '9', label: 'ط', value: 'ط' },
  { id: '10', label: 'ق', value: 'ق' },
  { id: '11', label: 'ع', value: 'ع' },
  { id: '12', label: 'ل', value: 'ل' },
  { id: '13', label: 'م', value: 'م' },
  { id: '14', label: 'ن', value: 'ن' },
  { id: '15', label: 'و', value: 'و' },
  { id: '16', label: 'هـ', value: 'هـ' },
  { id: '17', label: 'ی', value: 'ی' },
]

interface Props {
  onChangeTwoDigits?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined
  onChangeAlphabet?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined
  onChangeThreeDigits?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined
  onChangePlacement?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined
  twoDigits: string
  alphabet: string
  threeDigits: string
  placement: string
}

const InputNumberPlate: FC<Props> = ({
  onChangeTwoDigits,
  onChangeAlphabet,
  onChangeThreeDigits,
  onChangePlacement,
  threeDigits,
  twoDigits,
  alphabet,
  placement,
}) => {
  return (
    <Box sx={{ display: 'flex', direction: 'ltr' }}>
      <Input
        dir='ltr'
        inputProps={{ maxLength: 2 }}
        onChange={onChangeTwoDigits}
        placeholder='12'
        sx={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, marginRight: 0.5 }}
        value={twoDigits}
      />
      <Select
        dir='ltr'
        inputProps={{ maxLength: 1 }}
        items={types}
        onChange={onChangeAlphabet}
        sx={{ borderRadius: 0, marginRight: 0.5 }}
        value={alphabet}
      />
      <Input
        dir='ltr'
        inputProps={{ maxLength: 3 }}
        onChange={onChangeThreeDigits}
        placeholder='865'
        sx={{ borderRadius: 0, marginRight: 0.5 }}
        value={threeDigits}
      />
      <Input
        dir='ltr'
        endAdornment={
          <InputAdornment position='start'>
            <img src={iranflag} width='30px' />
          </InputAdornment>
        }
        inputProps={{ maxLength: 2 }}
        onChange={onChangePlacement}
        placeholder='55'
        sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
        value={placement}
      />
    </Box>
  )
}

export default InputNumberPlate
